import React from 'react';
import { NavItem } from '../types';
import { styles } from './Socials.css';

export type SocialsProps = {
  socialsLinks?: Array<NavItem>;
};
export const Socials = ({ socialsLinks }: SocialsProps) => {
  return socialsLinks ? (
    <div className={styles.socialsContainer}>
      {socialsLinks.map(social => {
        return (
          <a key={social.url} className={styles.iconLink} href={social.url}>
            <img src={social.icon} alt={social.ariaLabel} className={styles.socialIcon} />
          </a>
        );
      })}
    </div>
  ) : null;
};
